import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { hinhThucNopTienApi } from "../../../api/category/hinhThucNopTienApi";
import { IAccHinhThucNopTien } from "../../../model/respone/category/IAccHinhThucNopTien";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eAccHinhThucNopTienActionIds,
  IAccHinhThucNopTienActionTypes,
} from "../../action-types/category/IAccHinhThucNopTien";
import { rootActions } from "../../actions/rootActions";

export function* hinhThucNopTienSaga(): any {
  yield takeLatest(eAccHinhThucNopTienActionIds.LOAD_START, loadWorker);
  yield takeEvery(eAccHinhThucNopTienActionIds.SAVE_START, saveWorker);
  yield takeEvery(eAccHinhThucNopTienActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(hinhThucNopTienApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.hinhThucNopTien.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.hinhThucNopTien.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
function* saveWorker(action: IAccHinhThucNopTienActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IAccHinhThucNopTien;
  if (payload.id > 0) {
    res = yield call(hinhThucNopTienApi.Update, payload);
  } else {
    res = yield call(hinhThucNopTienApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.hinhThucNopTien.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.category.hinhThucNopTien.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* deleteWorker(action: IAccHinhThucNopTienActionTypes): any {
  const res: IBaseRespone = yield call(
    hinhThucNopTienApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.category.hinhThucNopTien.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.hinhThucNopTien.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}
